import { performanceMockDataset } from './mock-data'
import { performanceDatasetSchema, type PerformanceDataset, type PerformanceQuery } from './schema'

/**
 * Reports & Analytics API layer.
 *
 * DUMMY/PROTOTYPE: the backend metrics endpoint does not exist yet, so this
 * resolves fabricated figures from `mock-data.ts` after a short simulated
 * latency. The response is still run through `performanceDatasetSchema` so the
 * UI already consumes validated data — exactly as it will with the real API.
 *
 * When the endpoint ships, replace the body of `fetchPerformance` with the
 * commented `apiRequest(...)` call below and delete `mock-data.ts`. Nothing
 * else in the feature needs to change.
 */

/** Simulated network latency for the mock, in ms. */
const MOCK_LATENCY_MS = 350

export async function fetchPerformance(
  query: PerformanceQuery,
  signal?: AbortSignal,
): Promise<PerformanceDataset> {
  // --- REAL BACKEND (swap in when WEBLP metrics endpoint is live) ------------
  // return apiRequest('/v1/jastip/reports/performance', {
  //   schema: performanceDatasetSchema,
  //   searchParams: {
  //     period: query.period,
  //     start_date: query.startDate,
  //     end_date: query.endDate,
  //   },
  //   signal,
  // })
  // ---------------------------------------------------------------------------

  // DUMMY: resolve mock data, honouring abort so it behaves like a real request.
  const raw = await mockRequest(() => performanceMockDataset(query.period), signal)
  return performanceDatasetSchema.parse(raw)
}

/** Resolves `produce()` after a short delay, rejecting if the signal aborts. */
function mockRequest<T>(produce: () => T, signal?: AbortSignal): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Aborted', 'AbortError'))
      return
    }
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort)
      resolve(produce())
    }, MOCK_LATENCY_MS)

    const onAbort = () => {
      clearTimeout(timer)
      reject(new DOMException('Aborted', 'AbortError'))
    }
    signal?.addEventListener('abort', onAbort, { once: true })
  })
}
